/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-referral-code" style="display: none;">
<svg>
  <g id="error" viewBox="0 0 24 25">
    <path d="M13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5C12.5523 15.5 13 15.9477 13 16.5Z"></path>
    <path d="M11 10.5V14.5H13V10.5H11Z"></path>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5C12.3693 3.5 12.7086 3.70355 12.8824 4.02941L20.8824 19.0294C21.0477 19.3393 21.0382 19.7133 20.8575 20.0145C20.6768 20.3157 20.3513 20.5 20 20.5H4C3.64874 20.5 3.32323 20.3157 3.14251 20.0145C2.96178 19.7133 2.95235 19.3393 3.11765 19.0294L11.1176 4.02941C11.2914 3.70355 11.6307 3.5 12 3.5ZM18.3333 18.5L12 6.625L5.66667 18.5H18.3333Z"></path>
  </g>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
